export function generateSearchTitle(naturalQuery, committedFilters) {
    if (naturalQuery && naturalQuery.trim().length > 0) {
      return naturalQuery.charAt(0).toUpperCase() + naturalQuery.slice(1);
    }
    let industryPart = committedFilters.industryInclude.length > 0 ? committedFilters.industryInclude.join(" & ") : "Companies";
    let locationPart = committedFilters.locations.length > 0 ? `from ${committedFilters.locations.join(", ")}` : "";
    let title = `${industryPart} ${locationPart}`.trim();

    if (title === "Companies" && committedFilters.termsInclude.length > 0) {
      title = `Search for "${committedFilters.termsInclude.join(", ")}"`;
    }
    return title;
}
